import React, { PropsWithChildren } from "react";
import { useAuthStatus } from "../../hooks/useAuthStatus";
import Spinner from "../spinner";

const AuthGuard: React.FC<PropsWithChildren> = ({ children }) => {
    const { isLoggedIn, loading } = useAuthStatus();

    if (loading) {
        return <Spinner />;
    }

    if (!isLoggedIn) {
        // Full page redirect so WordPress serves the login template
        window.location.replace("/");
        return <Spinner />;
    }

    return <>{children}</>;
};

export default AuthGuard;
